export class utils {
    static isRequired(element) {
        return $(element).prop("required");
    }
    static log(message) {
        //console.log is not a JS standard
        try {
            console.log("DealeronLead: " + message);
        }
        catch (e) {
            /* empty */
        }
    }
    static getFieldsSelector(formId, dlronType) {
        return ("#" +
            formId +
            " [" +
            (dlronType == "file" ? "" : "data-dlron-") +
            "type='" +
            dlronType +
            "']");
    }
    static addValidationMethod(name, method, errorMsg) {
        $.validator.addMethod(name, method, errorMsg);
    }
}
